/*
 * Copyright 2026 Collaterate. All rights reserved.
 */

var configureglobals = new PageGlobals();

var controllerMode = {
    FIELD_CHANGE_QUOTE: 'FIELD_CHANGE_QUOTE',
    FULL_QUOTE: 'FULL_QUOTE'
};

window.addEventListener('FileUploadSessionIdSet', function (e) {
    if (e.detail) {
        common.fileSessionId = e.detail.sessionId || '';
        common.filePath = e.detail.filePath || '';
    }
});

var common = {
    fileSessionId: '',
    filePath: '',
    offeringId: configureCommonGlobals.offeringId,
    getOfferingName: function () {
        var offering = configureglobals.coffering;
        if (offering == null) {
            return '';
        }
        return offering.name;
    },
    setCQuoteData: function (object, quoteInitMessages) {
        // stub quoteInitMessages into cquotedata object
        object.setProperty('requoteInitMessages', 'SerializedObject', quoteInitMessages);
        configureglobals.set('cquotedata', object);
        this.validation = new JobQuoteValidation(object.validation);
        var content = '';

        // show any global validation messages
        content += this.validation.generateGlobalMessages();

        // show any quote init messages
        if (quoteInitMessages && quoteInitMessages.list && quoteInitMessages.list.length > 0) {
            var ul = new JDUL({
                cssClass: 'validationInfoMessage'
            });
            for (var i = 0, ni = quoteInitMessages.list.length; i < ni; i++) {
                ul.add(quoteInitMessages.list[i].value);
            }
            content += ul.generate();
        }

        dynamic.setDivIdContent('validationMessagesDiv', content);
    },
    setCQuote: function (cquote) {
        configureglobals.set('cquote', cquote);

        if (configureglobals.cquote) {
            window.tbg.eventHub.trigger(window.tbg.eventHub.events.QUOTE_SET, configureglobals.cquote);
        } else {
            window.tbg.eventHub.trigger(window.tbg.eventHub.events.QUOTE_SET, {});
        }

        if (cquote == null) {
            dynamic.setDivIdContent('jobQuotePrices', '--');
        } else {
            var content = '';
            var table = new JDTable({
                cssClass: 'quote'
            });
            table.addRow([
                {
                    text: (cquote.offeringDiscountPercent != 0 || cquote.userDiscountPercent != 0 ? 'Original ' : 'Your ') + 'Price',
                    tag: 'th',
                    scope: 'row'
                },
                {
                    text: '<span class="lineItemPrice">$' + cquote.jobTotalPriceDisplay + '</span>'
                }
            ], {
                cssClass: 'productPrice'
            });
            if (cquote.offeringDiscountPercent != 0 || cquote.userDiscountPercent != 0) {
                if (cquote.offeringDiscountPercent != 0) {
                    table.addRow([
                        {
                            text: '' + cquote.offeringDiscountPercent + '% Savings',
                            tag: 'th',
                            scope: 'row'
                        },
                        {
                            text: '<span class="lineItemPrice">-$' + cquote.jobOfferingDiscountPriceDisplay + '</span>'
                        }
                    ], {
                        cssClass: 'productDiscount'
                    });
                }
                if (cquote.userDiscountPercent != 0) {
                    table.addRow([
                        {
                            text: '' + strWeb(cquote.userDiscountName),
                            tag: 'th',
                            scope: 'row'
                        },
                        {
                            text: '<span class="lineItemPrice">-$' + cquote.jobUserDiscountPriceDisplay + '</span>'
                        }
                    ], {
                        cssClass: 'productDiscount userDiscount'
                    });
                }
                table.addRow([
                    {
                        text: 'Your Price',
                        tag: 'th',
                        scope: 'row'
                    },
                    {
                        text: '<span class="lineItemPrice">$' + cquote.totalPriceDisplay + '</span>'
                    }
                ], {
                    cssClass: 'productPrice discounted'
                });
            }
            content += table.generate();
            dynamic.setDivIdContent('jobQuotePrices', content);
        }
    },
    efVals: {},
    ef: null,
    efFocus: function (fieldName, containerDivId, buttonDivId) {
        this.ef = fieldName;
        this.efVals[fieldName] = getFormItemValue(fieldName, document);
        dynamic.addClass(containerDivId, 'focus');
        $('a.deleteVersion', this).hide();
        dynamic.setDivIdContent(buttonDivId, forms.button('Update', {
            cssClass: 'secondary config',
            tabindex: '-1'
        }));
    },
    efBlur: function (fieldName, containerDivId, buttonDivId, valueUpdatedCallbackFn) {
        var previousValue = this.efVals[fieldName];
        dynamic.removeClass(containerDivId, 'focus');
        dynamic.setDivIdContent(buttonDivId, '');
        var newValue = getFormItemValue(fieldName, document);
        if (previousValue !== newValue) {
            var configChangeDetails = {
                context: 'efBlur',
                category: confUtil.FIELD_CHANGE,
                fieldName: fieldName,
                fieldType: 'EF',
                previousValue: previousValue,
                newValue: newValue
            };
            configureEvents.onCalcChanged(configChangeDetails);

            if (typeof valueUpdatedCallbackFn === 'function') {
                valueUpdatedCallbackFn(newValue);
            }

            controller.getQuote(false, function () {
                controller.generateUI(configChangeDetails, { list: [] });
                configureEvents.onQuoteUpdated(configChangeDetails);
            }, function () { // on failure reset to the previous value.
                controller.generateUI(configChangeDetails, { list: [] });
            });

            this.ef = null;
        }
    },
    setContinueButtonEnabled: function (enabled) {
        $('.continueButton').prop('disabled', !enabled);
    },
    handleInvalidQuantity: function (fieldName, containerDivId, buttonDivId, valueUpdatedCallbackFn) {
        var previousValue = this.efVals[fieldName];
        dynamic.removeClass(containerDivId, 'focus');
        dynamic.setDivIdContent(buttonDivId, '');
        var newValue = null;
        var configChangeDetails = {
            context: 'handleInvalidQuantity',
            category: confUtil.FIELD_CHANGE,
            fieldName: fieldName,
            fieldType: 'EF',
            previousValue: previousValue,
            newValue: newValue
        };

        if (typeof valueUpdatedCallbackFn === 'function') {
            valueUpdatedCallbackFn(newValue);
        }

        common.setCQuote(null);
        var content = '<ul class="validationErrorMessage"><li>A quote was not completed.  Please make adjustments.<li><ul>';
        dynamic.setDivIdContent('validationMessagesDiv', content);
        quantityConfigureController.generateQuantity();
        configureEvents.onQuoteUpdated(configChangeDetails);

        this.ef = null;
    },
    setOptionDiv: function (divId, content) {
        if (content == '') {
            dynamic.setClass(divId, 'optionWrapperEmpty');
        } else {
            dynamic.setClass(divId, 'optionWrapperOn');
        }
        dynamic.setDivIdContent(divId, content);
    },
    generateProofs: function () {
        var coffering = configureglobals.coffering;
        if (coffering.getPublishedShowProof()) {
            var fieldName = 'PROOFDD';
            var content = '';
            var error = this.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var cofferingproofs = coffering.getPublishedProofs();
            var cproofs = new Array();
            for (var i = 0; i < cofferingproofs.length; i++) {
                var cofferingproof = cofferingproofs[i];
                cproofs[cproofs.length] = cofferingproof.proof;
            }
            var selectedproof = configureglobals.cquotedata.proof;
            var help = '';

            // show system level proof tip if showTip is true at system product level
            if (coffering.systemOffering.showProofTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.coffering.systemOffering,\'proofTip\',\'' + TBGBOTip.PROOFS + '\')', {
                    id: 'proofTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (coffering.getPublishedEditProof()) {
                content += help + '<label class="config">Proof</label>';
                content += forms.dd(fieldName, cproofs, selectedproof, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'common.setProof()'
                });
                if (error) {
                    content += this.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedproof != null) {
                    content += help + '<label class="config">Proof</label>';
                    content += tags.div(selectedproof.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            this.setOptionDiv('proofsDiv', content);
        }
    },
    setProof: function () {
        var newValue = getDropDownSelectedValue('PROOFDD', document);
        var configChangeDetails = {
            context: 'setProof',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PROOFDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cquotedata = configureglobals.cquotedata;
        cquotedata.setProof(newValue);
        controller.updateQuote(configChangeDetails);
    },
    generateTurnaroundTimes: function () {
        var coffering = configureglobals.coffering;
        if (coffering.getPublishedShowTurnaroundTime()) {
            var fieldName = 'TURNAROUNDTIMEDD';
            var content = '';
            var error = this.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var cofferingturntimes = coffering.getPublishedTurnaroundTimes();
            var cturntimes = new Array();
            for (var i = 0; i < cofferingturntimes.length; i++) {
                var cofferingturntime = cofferingturntimes[i];
                cturntimes[cturntimes.length] = cofferingturntime.turnaroundTime;
            }
            var cselectedturnaroundtime = configureglobals.cquotedata.turnaroundTime;
            var help = '';

            // show system level turnaround tip if showTip is true at system product level
            if (coffering.systemOffering.showTurnaroundTimeTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.coffering.systemOffering,\'turnaroundTimeTip\',\'' + TBGBOTip.TURNAROUNDTIMES + '\')', {
                    id: 'turnaroundTimeTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (coffering.getPublishedEditTurnaroundTime()) {
                content += help + '<label class="config">Production Time</label>';
                content += forms.dd(fieldName, cturntimes, cselectedturnaroundtime == null ? null : cselectedturnaroundtime, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'common.setTurnaroundTime()',
                    nameProperty: 'displayName'
                });
                if (error) {
                    content += this.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (cselectedturnaroundtime != null) {
                    content += help + '<label class="config">Production Time</label>';
                    content += tags.div(cselectedturnaroundtime.displayName, {
                        cssClass: 'noEdit'
                    });
                }
            }
            this.setOptionDiv('turnaroundTimesDiv', content);
        }
    },
    setTurnaroundTime: function () {
        var newValue = getDropDownSelectedValue('TURNAROUNDTIMEDD', document);
        var configChangeDetails = {
            context: 'setTurnaroundTime',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'TURNAROUNDTIMEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cquotedata = configureglobals.cquotedata;

        cquotedata.setTurnaroundTime(newValue);

        controller.updateQuote(configChangeDetails);
    },
    generateAdditionalFields: function () {
        var quoteData = configureglobals.cquotedata;
        var metadata = quoteData.metadata;
        var additionalFields = quoteData.additionalFields;
        var content = '';
        content += '<fieldset class="additionalInformation">';
        for (var i = 0, ni = metadata ? metadata.length : 0; i < ni; i++) {
            var metadataItem = metadata[i];
            var additionalFieldValue = '';
            if (additionalFields != null) {
                if (additionalFields[metadataItem.name]) {
                    additionalFieldValue = additionalFields[metadataItem.name];
                }
            }

            var datatype = metadataItem.dataType;
            content += '<div id="ai' + metadataItem.id + '" class="optionWrapperOn' + (metadataItem.required ? ' required' : '') + '">';
            if (datatype == 'EF') {
                content += tags.label(metadataItem.name, {
                    cssClass: 'config'
                }) + forms.ef('ADDITIONALFIELD' + i, strWeb(additionalFieldValue), {
                    cssClass: 'additionalText' + (metadataItem.required ? ' required' : ''),
                    onblur: 'common.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')'
                });
            } else if (datatype == 'TA') {
                content += tags.label(metadataItem.name, {
                    cssClass: 'config'
                }) + forms.ta('ADDITIONALFIELD' + i, strWeb(additionalFieldValue), {
                    rows: 4,
                    cssClass: 'additionalTA' + (metadataItem.required ? ' required' : ''),
                    onblur: 'common.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')'
                });
            } else if (datatype == 'DD') {
                var ddValues = metadataItem.preDefinedTextValues;
                content += tags.label(metadataItem.name, {
                    cssClass: 'config'
                }) + forms.dd('ADDITIONALFIELD' + i, ddValues.list, {
                    id: additionalFieldValue
                }, {
                    cssClass: 'configSelect additional' + (metadataItem.required ? ' required' : ''),
                    onchange: 'common.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')'
                });
            } else if (datatype == 'DP') {
                content += tags.label(metadataItem.name, {
                    cssClass: 'config'
                }) + forms.ef('ADDITIONALFIELD' + i, normalizeDateValue(additionalFieldValue), {
                    cssClass: 'additionalText' + (metadataItem.required ? ' required' : ''),
                    type: 'date',
                    autocomplete: 'nope',
                    onchange: 'common.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')'
                });
            } else if (datatype == 'CB') {
                content += tags.div(forms.cb('ADDITIONALFIELD' + i, metadataItem.name, additionalFieldValue, {
                    onchange: 'common.setAdditionalField(\'' + strWeb(metadataItem.name) + '\',' + i + ')',
                    cssClass: 'additionalCB'
                }));
            }

            content += '</div>';
        }
        content += '</fieldset>';
        dynamic.setDivIdContent('additionalProductFields', content);
    },

    setAdditionalField: function (question, id) {
        var cquotedata = configureglobals.cquotedata;
        var formItem = getFormItem('ADDITIONALFIELD' + id, document);
        if (formItem.type === 'checkbox') {
            cquotedata.setAdditionalField(question, formItem.checked);
        } else {
            cquotedata.setAdditionalField(question, formItem.value);
        }

        // For custom quote (Sales Estimate) context only, trigger a quote update on field change.
        // For normal storefront order entry, metadata is submitted with continueClicked() — no recalc needed as metadata fields do not affect pricing.
        if (configureCommonGlobals.SALES_ESTIMATE_MODE === true) {
            var configChangeDetails = {
                context: 'setAdditionalField',
                category: confUtil.INDEXED_FIELD_CHANGE,
                fieldIndex: id,
                fieldName: 'ADDITIONALFIELD',
                fieldType: 'EF',
                previousValue: null,
                newValue: null
            };

            configureEvents.onCalcChanged(configChangeDetails);
            controller.updateQuote(configChangeDetails);
        }
    },

    continueClicked: function () {
        if (this.isProcessing) {
            return;
        }

        if (configureCommonGlobals.REQUOTE_MODE && USER_TYPE !== 'STOREFRONT_USER') {
            if (hasValue(configuratorGlobals.nextStepUrl)) {
                var validator = new Validator();
                common.validation.setValidationErrorReasons(validator);
                if (!validator.isValid()) {
                    return;
                }
                var requoteData = controller.model.generateQuoteRequestData();
                sessionStorage.setItem('requoteData', JSON.stringify(requoteData));

                gotoURL(configuratorGlobals.nextStepUrl);
                return;
            }
        }

        var validator = new Validator();
        common.validateAdditionalFields(validator);

        if (validator.isValid()) {
            common.reason = '';
            this.isProcessing = true;
            common.addItemToCart()
                .catch(function (error) {
                    console.error('An error occurred while adding to cart', error);
                    this.isProcessing = false;
                });
        }
    }.bind(this),

    validateAdditionalFields: function (validator) {
        var quoteData = configureglobals.cquotedata;
        var quoteValidation = common.validation;
        quoteValidation.setValidationErrorReasons(validator);

        if (!configureCommonGlobals.REQUOTE_MODE) {
            validator.addItem(new CustomValidateItem(null, function () {
                var metadata = quoteData.metadata;
                this.reason = '';
                if (metadata != null) {
                    for (var i = 0; i < metadata.length; i++) {
                        var metadataItem = metadata[i];
                        if (metadataItem.required) {
                            var datatype = metadataItem.dataType;
                            if (datatype == 'EF' || datatype == 'DD' || datatype == 'TA' || datatype == 'DP') {
                                if (!itemHasValue(getFormItem('ADDITIONALFIELD' + i, document))) {
                                    this.reason += '"' + metadataItem.name + '"' + ' is required\n';
                                }
                            } else {
                                if (!isChecked('ADDITIONALFIELD' + i, document)) {
                                    this.reason += '"' + metadataItem.name + '"' + ' must be checked\n';
                                }
                            }
                        }
                    }
                }
                return this.reason == '';
            }));
        }
    },

    handleAddToCartError: function (errorResponse) {
        console.log('An error occurred while adding product to the cart. ' + JSON.stringify(errorResponse));
        window.isProcessing = false;
        if (errorResponse && errorResponse.errors && errorResponse.errors.length > 0 && +errorResponse.errors[0].status === 417) {
            var message = errorResponse.errors[0].detail;
            growlMessages.showErrorMessage(message);
        }
    },

    addItemToCart: function () {
        return tbg.apiV2({
            url: '/projects/v2/cart/addItem',
            method: 'PUT',
            contentType: 'application/json',
            customErrorHandler: this.handleAddToCartError,
            data: JSON.stringify(common.addOrderItemRequestData())
        }).then(function (response) {
            if (response) {
                var params = common.nextStepAdditionalParams(configuratorGlobals.nextStepUrl, response);
                common.gotoNextStep(params);
            }
        });
    },

    addOrderItemRequestData: function () {
        var quoteData = configureglobals.cquotedata;

        return {
            userId: common.getUserId(),
            fileSessionId: common.fileSessionId,
            filePath: common.filePath,
            clientKey: common.getUserId() === null ? common.getCookieByName('anonymous-user-cart') : null,
            jobName: common.getOfferingName(),
            quantity: quoteData.quantity,
            proofId: quoteData.proof ? quoteData.proof.id : null,
            turnTimeId: quoteData.turnaroundTime ? quoteData.turnaroundTime.id : null,
            productInfoId: common.getProductInfo(),
            metaData: quoteData.additionalFields,
            orderItemId: getUrlParms().reorder || getUrlParms().orderItemId,
            copyFiles: getUrlParms().r === 'y',
            podTemplateSessionCode: getUrlParms().s,
            forReorder: getUrlParms().reorder != null && getUrlParms().p == null,
            quoteDataOverrides: quoteData.jobSpecOverrides
        };
    },

    getProductInfo: function () {
        return {
            siteId: configureCommonGlobals.siteId,
            idWithPrefix: configureCommonGlobals.idWithPrefix
        };
    },

    getCookieByName: function (name) {
        var match = document.cookie
            .match(new RegExp('(^|;\\s*)' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        }

        return null;
    },

    getUserId: function () {
        if (typeof globalpageglobals !== 'undefined' && globalpageglobals && globalpageglobals.cuser != null) {
            return globalpageglobals.cuser.id;
        }
        return null;
    },

    gotoNextStep: function (params) {
        if (!hasValue(configuratorGlobals.nextStepUrl)) {
            return;
        }

        if (configuratorGlobals.nextStepUrl.toLowerCase().includes('/plugin')) {
            var url = configuratorGlobals.nextStepUrl;
            if (url.includes('itemId')) {
                gotoURL(url);
            } else {
                var paramsStr = new URLSearchParams(params).toString();
                var separator = url.includes('?') ? '&' : '?';
                gotoURL(url + (hasValue(paramsStr) ? separator + paramsStr : ''));
            }
        } else {
            var existingParams = getUrlParms().reduce(function (map, key) {
                var value = getUrlParm(key);
                if (hasValue(key) && hasValue(value)) {
                    map[key] = value;
                }
                return map;
            }, {});
            var mergedParams = Object.keys(params).length === 0 ? {} : Object.assign({}, existingParams, params);
            var paramsStr = new URLSearchParams(mergedParams).toString();

            gotoURL(configuratorGlobals.nextStepUrl + (hasValue(paramsStr) ? '?' + paramsStr : ''));
        }
    },

    nextStepAdditionalParams: function (nextStepUrl, response) {
        var params = {};

        // Order item params
        var orderItemIdPaths = ['/upload/', '/personalize/', '/plugin/'];

        var shouldAddOrderItemId = orderItemIdPaths.filter(function (path) {
            return hasValue(nextStepUrl) && nextStepUrl.toLowerCase().includes(path);
        });

        if (shouldAddOrderItemId.length > 0) {
            params.orderItemId = response.orderItem.id;
        }

        return params;
    },

    validateTotalPriceOverrideAmount: function (generateOverrideAmountDiv) {
        var enteredAmount = getFormItemValue('TOTAL_PRICE_OVERRIDE_AMOUNT_EF', document);
        var cleanedAmount = enteredAmount ? enteredAmount.replace(/,/g, '') : enteredAmount;
        var cquotedata = configureglobals.cquotedata;

        if (cleanedAmount && isNaN(+cleanedAmount)) {
            cquotedata.clearFieldErrors('TOTAL_PRICE_OVERRIDE_AMOUNT_EF');
            cquotedata.clearGlobalErrors();
            cquotedata.addFieldError('TOTAL_PRICE_OVERRIDE_AMOUNT_EF', 'Override Amount must be a dollar amount.');
            cquotedata.addGlobalError('A quote was not completed.  Please make adjustments.');
            dynamic.setDivIdContent('validationMessagesDiv', '<ul class="validationErrorMessage"><li>A quote was not completed.  Please make adjustments.</li></ul>');
            common.setCQuote(null);
            generateOverrideAmountDiv();
            return true;
        }
        return false;
    },
    showValidationMessages: function (quoteResponse, showAsGrowlMessages) {
        if (showAsGrowlMessages) {
            growlMessages.showAllRestMessages(quoteResponse);
        } else {
            var quoteWarningMessages = this.validation.buildWarningList(quoteResponse);

            for (var i = 0; i < quoteWarningMessages.length; i++) {
                this.validation.cvalidation.globalInfoMessages.push({ value: quoteWarningMessages[i] });
                this.validation.cvalidation.hasGlobalInfoMessages = true;
            }

            var content = this.validation.generateGlobalMessages();
            dynamic.setDivIdContent('validationMessagesDiv', content);
        }
    }
};
